import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';

import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import MonthDropdown from '@/components/ui/date-picker/MonthDropdown';
import { useGetgetBalanceActionHistory } from '@/service/payment/hook';
import { getCoreRowModel, PaginationState, useReactTable } from '@tanstack/react-table';
import { DataTableManual } from '@/components/ui/data-table/DataTableManual';

const BalanceHistory = () => {
  const [month, setMonth] = useState(dayjs().format('YYYY-MM'));
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const handleSelect = (selectedMonth: string) => {
    setMonth(selectedMonth);
  };
  const { data } = useGetgetBalanceActionHistory(
    {
      startDate: dayjs(month).startOf('month')?.toISOString(),
      endDate: dayjs(month).endOf('month')?.toISOString(),
      pageIndex: pagination?.pageIndex,
      pageSize: pagination?.pageSize,
    },
  );

  const table = useReactTable({
    data: data?.rows ?? [],
    columns,
    pageCount: data?.pageCount,
    state: {
      pagination,
    },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    manualPagination: true,
  });

  return (
    <>
      <div>
        <div className="flex flex-col gap-4">
          <MonthDropdown onSelect={handleSelect} defaultMonth={month} />
          {/* <Card className='p-4'> */}
          <DataTableManual
            columns={columns}
            table={table}
          />
        </div>
      </div>
    </>
  );
};

export default BalanceHistory;
